var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandScglab2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 30,
    viewBox: "0 0 171 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 23.7154L3.95445 21.3038C5.15288 23.4289 7.38354 24.6428 9.96353 24.6428C12.9769 24.6428 15.2572 23.1758 15.2572 21.1021C15.2572 18.5892 11.7283 17.0715 8.59851 15.7056C5.45239 14.2883 1.95674 12.636 1.95674 8.36936C1.95674 3.91764 5.76864 0.814453 10.5962 0.814453C14.4249 0.814453 17.288 2.68642 18.387 5.67112L15.2572 7.86327C14.4249 6.0256 12.5772 4.99686 10.6295 4.99686C8.16589 4.99686 6.20146 6.54806 6.20146 8.4707C6.20146 10.5958 8.68181 11.3543 11.9447 12.7706C16.1894 14.6599 19.4856 16.7344 19.4856 21.0171C19.4856 25.8405 15.3572 28.9437 9.91352 28.9437C5.50221 28.9437 2.15641 26.8521 0.625 23.7154Z",
    fill: "#059DE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3516 14.9129C22.3516 7.24732 29.0669 0.814453 37.0933 0.814453C40.7962 0.864987 44.2159 2.36755 47.0154 4.96762L44.4108 8.32786C42.4086 6.42024 39.8039 5.15318 37.0046 5.15318C31.8308 5.15318 26.8874 9.47551 26.8874 14.9293C26.8874 20.4172 31.9019 24.6547 37.0222 24.6547C39.9458 24.6547 42.4618 23.2708 44.4284 21.4129L47.0154 24.8574C44.5527 27.1707 41.4163 28.9437 37.1639 28.9437C29.0669 28.9437 22.3516 22.5949 22.3516 14.9129Z",
    fill: "#059DE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.628 15.7569C74.628 23.8449 68.6621 28.9437 61.4793 28.9437C53.4393 28.9437 47.0625 22.6286 47.0625 14.9125C47.0625 7.18022 53.4735 0.814453 61.3249 0.814453C64.8051 0.831623 68.7819 2.48594 71.3881 4.98468L68.9707 8.53036C66.8107 6.43706 63.8964 5.12028 61.2734 5.12028C56.2338 5.12028 51.468 9.27353 51.468 14.9125C51.468 20.2485 55.7709 24.6378 61.668 24.6378C66.4164 24.6378 69.9822 21.7842 69.9822 17.6311V17.5471H61.4277V13.6293H74.5081C74.5765 14.2546 74.628 14.9976 74.628 15.7569Z",
    fill: "#059DE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.291 25.0065V29.1837H103.332V2.46094H107.486V25.0065H119.291Z",
    fill: "#059DE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137 11.1547L128.871 28.9437H123.934L136.863 0.814453H137.119L150.048 28.9437H145.093L137 11.1547Z",
    fill: "#059DE7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.371 24.8763H155.797V16.6872L161.303 16.6703C164.412 16.6703 166.179 18.5273 166.179 20.5499C166.179 23.1356 163.835 24.8763 161.371 24.8763ZM155.797 6.32663H161.109C163.046 6.32663 164.746 7.75186 164.746 9.65773C164.746 11.5646 163.183 12.9898 161.059 12.9739L155.797 12.9898V6.32663ZM165.694 14.2418C167.081 13.9593 168.773 11.8009 168.773 9.11139C168.773 5.56325 165.578 2.24805 160.855 2.24805H151.516V13.9185V28.9708H161.762C167.199 28.9708 170.376 24.9259 170.376 20.8314C170.376 17.5019 168.156 15.079 165.694 14.2418Z",
    fill: "#059DE7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2461 12.0633H92.0494V6.4375H86.2461V12.0633Z",
    fill: "#059DE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2461 23.3075H92.0494V17.6816H86.2461V23.3075Z",
    fill: "#059DE7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4492 17.6805H86.2525V12.0547H80.4492V17.6805Z",
    fill: "#059DE7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9883 17.6805H97.7915V12.0547H91.9883V17.6805Z",
    fill: "#059DE7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandScglab2);
export default __webpack_public_path__ + "static/media/brand-scglab2.cd7e650cd274a219cb7ac8bfd944d474.svg";
export { ForwardRef as ReactComponent };